import React, { useEffect } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Hero from "../components/hero"
import Endorsement from "../components/endorsement"
import Statistics from "../components/statistics"
import ServicePromo from "../components/servicePromo"
import BulletPoints from "../components/bulletPoints"
import JlFamily from "../components/jlFamily"
import ContactForm from "../components/contactForm"

const IndexPage = (props) => {
    return (
        <Layout>
            <SEO title="Sell Your Service Center" />
            <Hero/> 
            <BulletPoints/>
            <ServicePromo/>                
            <ContactForm search={props.location.search} />
        </Layout>
    );
}

export default IndexPage
